import { TCreateFirmwareAction, CreateFirmwareActionTypes } from './createFirmwareActions';
import { ICreateFirmwareState } from './createFirmwareContext';

export const createFirmwareReducer = (
	state: ICreateFirmwareState,
	action: TCreateFirmwareAction,
): ICreateFirmwareState => {
	switch (action.type) {
		case CreateFirmwareActionTypes.SET_TYPE_SELECTED_FIRMWARE:
			return {
				...state,
				typeSelectedFirmware: action.payload.typeSelectedFirmware,
			};
		case CreateFirmwareActionTypes.CHANGE_NAME_OF_FIRMWARE:
			return {
				...state,
				nameOfFirmware: action.payload.nameOfFirmware,
			};
		case CreateFirmwareActionTypes.CHANGE_VERSION_OF_FIRMWARE:
			return {
				...state,
				versionOfFirmware: action.payload.versionOfFirmware,
			};
		case CreateFirmwareActionTypes.CHANGE_DESCRIPTION:
			return {
				...state,
				description: action.payload.description,
			};
		case CreateFirmwareActionTypes.CHANGE_FILE_DATA:
			return {
				...state,
				fileData: action.payload.fileData,
			};
		case CreateFirmwareActionTypes.SET_DATA_FOR_SUBMIT:
			return {
				...state,
				dataForSubmit: action.payload.dataForSubmit,
			};
		case CreateFirmwareActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case CreateFirmwareActionTypes.RESET_FIELDS:
			return {
				...state,
				typeSelectedFirmware: 1,
				nameOfFirmware: '',
				versionOfFirmware: '',
				description: '',
				fileData: {
					fileId: '',
					fileHash: null,
					fileName: null,
				},
				dataForSubmit: null,
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
